/**
 * プレイヤー固有の設定・状態(配信ゲームをまたいで保持される項目もあり、
 * セーブとは独立した player config + 既読状態を含む)。
 */

export interface PlayerConfig {
  textSpeed: number; // ms/char、0 で瞬時表示
  autoDelayMs: number; // メッセージ表示完了後、次へ進むまでの待機 ms
  bgmVolume: number; // 0..1
  seVolume: number;
  voiceVolume: number;
}

export interface BacklogEntry {
  speaker: string | null;
  text: string;
  timestamp: number;
}

export class PlayerState {
  config: PlayerConfig = {
    textSpeed: 28,
    autoDelayMs: 1400,
    bgmVolume: 0.6,
    seVolume: 0.8,
    voiceVolume: 1.0,
  };

  autoMode = false;
  skipMode = false;
  visited = new Set<string>(); // file#cmdIndex
  backlog: BacklogEntry[] = [];

  constructor(private gameId: string) {
    this.load();
  }

  isRead(file: string, cmdIndex: number): boolean {
    return this.visited.has(`${file}#${cmdIndex}`);
  }

  markRead(file: string, cmdIndex: number): void {
    this.visited.add(`${file}#${cmdIndex}`);
    this.persistDebounced();
  }

  pushBacklog(entry: BacklogEntry): void {
    this.backlog.push(entry);
    if (this.backlog.length > 120) this.backlog.shift();
  }

  clearBacklog(): void {
    this.backlog = [];
  }

  setConfig(patch: Partial<PlayerConfig>): void {
    this.config = { ...this.config, ...patch };
    this.persistConfig();
  }

  private save(): void {
    this.persistConfig();
    this.persistVisited();
  }

  private persistConfig(): void {
    try {
      localStorage.setItem(`pix-config:${this.gameId}`, JSON.stringify(this.config));
    } catch {
      /* ignore */
    }
  }

  private persistVisited(): void {
    try {
      localStorage.setItem(
        `pix-visited:${this.gameId}`,
        JSON.stringify([...this.visited]),
      );
    } catch {
      /* ignore */
    }
  }

  private persistTimer: number | null = null;
  private persistDebounced(): void {
    if (this.persistTimer !== null) return;
    this.persistTimer = window.setTimeout(() => {
      this.persistTimer = null;
      this.persistVisited();
    }, 500);
  }

  private load(): void {
    try {
      const cfg = localStorage.getItem(`pix-config:${this.gameId}`);
      if (cfg) this.config = { ...this.config, ...JSON.parse(cfg) };
    } catch {
      /* ignore */
    }
    try {
      const vis = localStorage.getItem(`pix-visited:${this.gameId}`);
      if (vis) {
        const arr = JSON.parse(vis) as string[];
        this.visited = new Set(arr);
      }
    } catch {
      /* ignore */
    }
  }
}
